import React from 'react';
import T from 'prop-types';
import { withRouter } from 'react-router';
import { ContextNavigation, Tooltip } from '@acast/decibel';
import { connect } from 'react-redux';
import { selectShowFeatureFlags } from 'ducks/feature-flags';
import { selectEpisodeAccessHasChanged } from 'ducks/access';
import Features from 'app/features';
import {
  PencilRegularGlyph,
  BullhornSolidGlyph,
  AcastAccessGlyph,
  ShareSquareRegularGlyph,
} from '@acast/decibel-glyphs';
import { Episode } from '../../../resources';
import resourceProp from '../../../shared/helpers/resource-prop';
import navigateTo from '../../../shared/helpers/navigate-to';
import { reactRouterLocationPropType } from '../../../customPropTypes';

const isSelectedPath = (location, path) => {
  return location.pathname.includes(path);
};

const EpisodePageNavigation = props => {
  const { episode, hasLocalAccessChanges, location } = props;

  const episodeId = episode.pending ? '' : episode.data.id;
  const showId = episode.pending ? '' : episode.data.show;
  const isModified = episode.pending ? false : episode.data.isModified;
  const modifiedIndicator =
    isModified || hasLocalAccessChanges ? (
      <Tooltip title="You have pending changes" placement="right">
        <Tooltip.Indicator />
      </Tooltip>
    ) : null;

  return (
    <ContextNavigation onBackClick={() => navigateTo(`/shows/${showId}`)}>
      <ContextNavigation.Item
        onClick={() => navigateTo(`/episodes/${episodeId}/settings`)}
        glyph={PencilRegularGlyph}
        selected={isSelectedPath(location, `/episodes/${episodeId}/settings`)}
      >
        Episode Details
      </ContextNavigation.Item>
      {props.hasAcastAccess && (
        <ContextNavigation.Item
          onClick={() => navigateTo(`/episodes/${episodeId}/access-settings`)}
          glyph={AcastAccessGlyph}
          selected={isSelectedPath(location, `/episodes/${episodeId}/access-settings`)}
          data-test-id="acast-access-setting-link"
        >
          Access Settings
        </ContextNavigation.Item>
      )}
      <ContextNavigation.Item
        onClick={() => navigateTo(`/episodes/${episodeId}/editor`)}
        glyph={BullhornSolidGlyph}
        selected={isSelectedPath(location, `/episodes/${episodeId}/editor`)}
      >
        Edit Markers
      </ContextNavigation.Item>
      <ContextNavigation.Item
        onClick={() => navigateTo(`/episodes/${episodeId}/publish`)}
        glyph={ShareSquareRegularGlyph}
        selected={isSelectedPath(location, `/episodes/${episodeId}/publish`)}
      >
        Publish Settings
        {modifiedIndicator}
      </ContextNavigation.Item>
    </ContextNavigation>
  );
};

EpisodePageNavigation.propTypes = {
  episode: resourceProp(Episode),
  location: reactRouterLocationPropType.isRequired,
  hasAcastAccess: T.bool.isRequired,
  hasLocalAccessChanges: T.bool.isRequired,
};

export default connect((state, props) => {
  const showId = props.episode.data.show;
  const episodeId = props.episode.data.id;
  const featureFlags = selectShowFeatureFlags(showId)(state);
  const hasLocalAccessChanges = selectEpisodeAccessHasChanged(state, episodeId);

  return {
    hasAcastAccess: featureFlags.includes(Features.AcastAccess),
    hasLocalAccessChanges,
  };
})(withRouter(EpisodePageNavigation));
